'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dJ$002dW$002dToken$0024 from "./presto.types$-J-W-Token$.js";
import * as $j_presto$002etypes$0024$002dTenant$002dId$0024 from "./presto.types$-Tenant-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginHelper$$anon$2(outer) {
  this.b3H = null;
  this.b3F = null;
  this.b3G = false;
  this.b3D = null;
  this.b3E = false;
  this.b3I = false;
  this.b3J = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.b3H = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_LoginHelper$$anon$2 as $c_Lpresto_LoginHelper$$anon$2 };
$p = $c_Lpresto_LoginHelper$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginHelper$$anon$2;
/** @constructor */
function $h_Lpresto_LoginHelper$$anon$2() {
}
export { $h_Lpresto_LoginHelper$$anon$2 as $h_Lpresto_LoginHelper$$anon$2 };
$h_Lpresto_LoginHelper$$anon$2.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.b3H;
});
$p.t = (function() {
  if ((!this.b3G)) {
    this.b3F = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("token", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tenantId", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b3G = true;
  }
  return this.b3F;
});
$p.ad = (function() {
  if ((!this.b3E)) {
    this.b3D = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dJ$002dW$002dToken$0024.$m_Lpresto_types$JWToken$().cHz(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dTenant$002dId$0024.$m_Lpresto_types$TenantId$().cHQ()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b3E = true;
  }
  return this.b3D;
});
$p.v = (function() {
  if ((!this.b3J)) {
    this.b3I = false;
    this.b3J = true;
  }
  return this.b3I;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_LoginHelper$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginHelper$$anon$2, "presto.LoginHelper$$anon$2", ({
  M5: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_LoginHelper$$anon$2 as $d_Lpresto_LoginHelper$$anon$2 };
//# sourceMappingURL=presto.-Login-Helper$$anon$2.js.map
